/* simplify zip ranges of contact persons which could be a nested array or contain empty strings */
export const parseZipRanges = (contactPerson) => ({
        ...contactPerson,
        "zip_range": (contactPerson.zip_range || []).flat().filter(item => item.trim() !== "")
    }
)

/* test whether a single zip is contained inside an array with multiple single zip codes or zip ranges separated by a dash */
export const isIncludedByZipRange = (zipRanges = [], comparedZip) => {
    return zipRanges.some(zipRange => {
        if(zipRange.includes("-")) {
            const [min, max] = zipRange.split('-');

            return comparedZip >= +min && comparedZip <= +max;
        } else {
            return comparedZip === zipRange
        }
    });
}

export const areArraysIdentical = (arr1, arr2) => {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    return arr1.every(item => set2.has(item)) &&
        arr2.every(item => set1.has(item))
}

export const printContacts = (contacts) => {
    console.log("################################################")
    console.log("FILTERED LIST CONTACT-PERSONS:")
    console.table(contacts.map(contact => ({ uid: contact.uid, name: contact.first_name + " " + contact.last_name, zip_range: JSON.stringify(contact.zip_range), country: contact.country_static })))
    console.log("################################################")
}